import { render, staticRenderFns } from "./DfpSlot.vue?vue&type=template&id=5d1c4280&"
import script from "./DfpSlot.vue?vue&type=script&lang=js&"
export * from "./DfpSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports